
import { useState, useRef } from 'react';
import logo from './logo.png'
import logo_poziom from './logo_poziom.png'
import mini_lock from './mini_lock.png'
import Config from './Config';
import InputUsername from './helpers/InputUsername';
import InputPassword from './helpers/InputPassword';
import InputPhone from './helpers/InputPhone';
import InputEmail from './helpers/InputEmail';
import InputInteger from './helpers/InputInteger';
import InputText from './helpers/InputText';


function LoginForm(props)
{

    var defUser = '';
    var defUserV = false;
    var defPass = '';
    var defPassV = false;


    const [view, setView] = useState('form');

    const btnRef = useRef(0);
   

    var dU =  sessionStorage.getItem("def_username")+"" ;
    var dP =  sessionStorage.getItem("def_pass")+"";
    var dId =  sessionStorage.getItem("def_place")+"";

    if(dId == null || dId == undefined) dId = -1;

   // console.log("LoginForm ", dU, dP);

    if(dU != null  && dU != 'null'  && dU != undefined &&  dU.length > 3 )
    {        
            defUser = dU;
            defPass = dP;

            defUserV = true;
            defPassV = true;  
            
            console.log("eee", dU, dP);
          //  localStorage.clear();   
    }

    //sessionStorage.clear();

  


    const [req, setReq] = useState(
        {
            username: defUser,
            username_c: defUserV,
            password: defPass,
            password_c: defPassV,
            plDef: dId,
            driver_name: 'PC',
            auth2_code: '',
        }
    );
    const [msg, setMsg] = useState("");


    const [reqBack, setReqBack] = useState(
        {
            email: '',                   
            phone: '',            
        }
    );

    const [reqPass, setReqPass] = useState(
        {
            password: '',                   
            password2: '',       
            code: '',            
        }
    );


  
    

 const [responseUser, setResponseUser] = useState(null);
 const [auth2Crypt, setAuth2Crypt] = useState('');  //czy wyswietlic ekran autoryacji dwuetapowej




    const [versionStatus, setVersionStatus] = useState(0); // 0 - niesprawdzono, 1- sprawdzam, 2 - sprawdzono



    const valChange = (filedName, val, correct, msg) => {        
        setReq( {...req,  [filedName]:val, [filedName+"_c"]:correct } );    
    }

    const goNext = () => {

       console.log("goNext");
        sendData(btnRef);
        //sendData();
    }



    const valChange2 = (filedName, val, correct, msg) => {        
        setReqBack( {...reqBack,  [filedName]:val, [filedName+"_c"]:correct } );    
    }

    const goNext2 = () => {
      //  sendData();
    }



    const valChange3 = (filedName, val, correct, msg) => {        
        setReqPass( {...reqPass,  [filedName]:val, [filedName+"_c"]:correct } );    
    }

    const goNext3 = () => {
      //  sendData();
    }



    const showLoginForm = () => {
        setMsg("");
        setView("form");
    }

    const showPassBackForm = () => {
        setMsg("");
        setView("back1");
    }

    const showNewPassForm = () => {
        setMsg("");
        setView("back2");

        setReqPass( {
            password: '',                   
            password2: '',       
            code: '',            
        });
    }




    const checkVersion = () => {
                                    
                            var dt = { 
                                'clock': 1,
                                'version': Config.app_version,
                             }

            
                            fetch( Config.url + '/rest_v1,check_version_x', {
                                method: 'POST', 
                                body: JSON.stringify(dt), 
                                headers: {
                                    'Content-Type': 'text/html',
                                    'X-API-KEY': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => {                                           
                            
                               
                                setVersionStatus(2); //gotowe

                                if(res.status != null && res.status != undefined)
                                {
 
                                        if(res.status == 'OK' || res.status == 'ok' )
                                        {
                                          
                                        }


                                        if(res.status == 'VERSION' || res.status == 'version')
                                            {

                                               alert("Nowa wersja panelu zostanie teraz pobrana.");
                                               document.location.reload();
                                            }                                    
                                }
                                
                            } )
                            .catch(err => {
                                console.log("Err " + err);
                            });                                    
               

   }
    
    

   const resetLogin = (e) => {    
        setAuth2Crypt('');
        setResponseUser(null);
        setMsg(""); 
   }
   

   const sendDataAuth2 = (e) => {


     if(e == null || e == undefined) {
        e = btnRef;
     }

     setMsg(""); 


       if(req.auth2_code.length < 4)
        {
            setMsg("Podaj prawidłowy kod bezpieczeństwa.");
            return false;
        }

        console.log("Ex", e);

       var defTxt = "...";
       if(e != undefined && e.current != undefined)
       {
         defTxt = e.current.innerHTML;     
         e.current.innerHTML = "Czekaj...";
       }

       if(e != undefined && e.target != undefined)
        {
          defTxt = e.target.innerHTML;     
          e.target.innerHTML = "Czekaj...";
        }


        var xReq = {
            crypt: auth2Crypt,
            code: req.auth2_code,
        };


         fetch( Config.url + '/rest_v1,go_login_auth2', {
            method: 'POST', 
            body: JSON.stringify(xReq), 
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {

            if(e != undefined && e.current != undefined)
            {
                  e.current.innerHTML = defTxt;
            }

            if(e != undefined && e.target != undefined)
            {
                   e.target.innerHTML = defTxt;
            }



               if(res.status == 'OK')
               {
                      //zaloguj bez autoryzacji dwuetapowej...    
                        props.setUser(
                                    //    responseUser.apiKey,
                            res.param,         
                            responseUser.name,
                            responseUser.last_name,
                            responseUser.max_sec,
                            responseUser.type,
                            responseUser.crm_style,
                            responseUser.pl,
                            responseUser.dz,
                            req.plDef, //wybrana placowka
                            -1, //nie wybrano dziecka
                            responseUser, //wszystkie dane
                        );
                   
               }

               if(res.status == 'ERROR')
               {
                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Błędny kod bezpieczeństwa lub kod stracił ważność.');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });
                   


        return false;

   }


    const sendData = (e) => {

        setMsg("");  
 
        console.log("REQ", req);

        if(req.username_c == false)
        {
            setMsg("Podaj prawidłowy adres e-mail.");
            return;
        }

        if(req.password_c == false)
        {
            setMsg("Podaj prawidłowe hasło.");
            return;
        }


       if(e != undefined && e.current != undefined)
       {
        var defTxt = e.current.innerHTML;     
         e.current.innerHTML = "Czekaj...";
       }

       if(e != undefined && e.target != undefined)
        {
         var defTxt = e.target.innerHTML;     
          e.target.innerHTML = "Czekaj...";
        }


    
        
        fetch( Config.url + '/rest_v1,go_login', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {

            if(e != undefined && e.current != undefined)
            {
               e.current.innerHTML = defTxt;
            }

            if(e != undefined && e.target != undefined)
                {
                   e.target.innerHTML = defTxt;
                }

               if(res.status == 'OK')
               {
                    if(res.param.auth_f2 != null && res.param.auth_f2 == 1 )  //wymagana autoryzacja dwuetapowa
                    {
                        setResponseUser(res.param);    
                        setAuth2Crypt(res.param.auth_crypt);
                    }
                    else 
                    {
                      
                        //zaloguj bez autoryzacji dwuetapowej...    
                        props.setUser(
                            res.param.apiKey,
                            res.param.name,
                            res.param.last_name,
                            res.param.max_sec,
                            res.param.type,
                            res.param.crm_style,
                            res.param.pl,
                            res.param.dz,
                            req.plDef, //wybrana placowka
                            -1, //nie wybrano dziecka
                            res.param, //wszystkie dane
                        );

                    }

                    
                   
               }

               if(res.status == 'ERROR')
               {
                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Błędny login lub hasło');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });
                   

         return false;
    }



    const sendCode = (e) => {

        setMsg("");  

      
 
 
        if(reqBack.email.length < 10 || reqBack.email_c == false)
        {
            setMsg("Podaj adres e-mail");
            return;
        }

        if(reqBack.phone < 1 || reqBack.phone_c == false)
            {
                setMsg("Podaj numer telefonu");
                return;
            }


        var defTxt = e.target.innerHTML;     
        e.target.innerHTML = "Czekaj...";




        
        fetch( Config.url + '/rest_v1,pass_code', {
            method: 'POST', 
            body: JSON.stringify(reqBack), 
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {


               e.target.innerHTML = defTxt;

               if(res.status == 'OK')
               {
                        showNewPassForm();
               }

               if(res.status == 'ERROR')
               {
                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Podane dane są nieprawidłowe.');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });
                   

         return false;
    }



    const sendPass = (e) => {

        setMsg("");  

   

 
        if(reqPass.password.length < 10 || reqPass.password_c == false  )
        {
            setMsg("Podaj nowe hasło wg. wytycznych");
            return;
        }

        if(reqPass.password2 < 10 || reqPass.password2_c == false ||  reqPass.password != reqPass.password2)
            {
                setMsg("Powtórz prawidłowo hasło");
                return;
            }

      
      //  reqPass["username"]     = reqBack.


        var defTxt = e.target.innerHTML;     
        e.target.innerHTML = "Czekaj...";




        reqPass["email"] = reqBack.email;
        reqPass["phone"] = reqBack.phone;

        
        fetch( Config.url + '/rest_v1,pass_back', {
            method: 'POST', 
            body: JSON.stringify(reqPass), 
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {


               e.target.innerHTML = defTxt;

              
               if(res.status == 'OK')
               {
                        showLoginForm();
               }
              
               if(res.status == 'ERROR')
               {
          
                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Podane dane są nieprawidłowe.');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });
                   

         return false;
    }


     function handleSubmit(event){
        event.preventDefault();
    }


    var msgDialog = ( <br></br> )
    if( msg != undefined && msg != null &&  msg.length > 0)
    {
        msgDialog = (
            <div className='msg_error'>{msg}</div>
        )
    }


    if(versionStatus == 0)
    {
        setVersionStatus(1); //sprawdzam
        checkVersion();
    }


    if(view == 'back1')
    {
        return (
            <div className='elizak '>
    
                   

                     
    
                    <div className="form_content">
    
                        <img src={logo_poziom} className="img_logo" />
                                            
                        {msgDialog}
                        <br/>
                        <form className="form"  onSubmit={handleSubmit} >

                                    <div> Aby ustawić nowe hasło podaj prawidłowy adres e-mail oraz numer telefonu. </div>
                                    <br/>
    
                                   <div className='filedset_block'>
                                    <InputText  value={reqBack.email} valChange={valChange2} goNext={goNext2} name="email" placeholder={ "Email lub login: "} className='p100' req='1' />                                
                              
                                    <InputPhone type="password" value={reqBack.phone} valChange={valChange2} goNext={goNext2} name="phone" placeholder={"Telefon: "} className='p100'  req='1' />                      
                                    </div>
                                <br/>
                                <fieldset>
                                   <span href='' className='btn' onClick={sendCode} ref={btnRef}>Dalej</span>
                                </fieldset> 
    
                        </form>
                        <br/>
                        <br/>
                        <div>
                             <span className='link_normal' onClick={showLoginForm}>wróć do logowania</span>                         
                        </div>
                    </div>
    
                    <div className='e_foot_x'>
                    Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl 2024
                </div>
            </div>
        )


    }
    

    if(view == 'back2'  )
        {
            return (
                <div className='elizak '>
        
                     
                     
        
                        <div className="form_content">
        
                            <img src={logo_poziom} className="img_logo" />
                                                
                            {msgDialog}
                            <br/>
                            <form className="form" onSubmit={handleSubmit}  >

                                       <div>Nowe hasło musi zawierać min. 8 znaków, małe i DUŻE litery, cyfry i znaki specjalne (!@#$...) </div>
                                       <br/>
        
                                       <div className='filedset_block'>


                                           <InputPassword type="password" value={reqPass.password} valChange={valChange3} goNext={goNext3} name="password" placeholder={"Nowe hasło: "} className='p100'  req='1' />                      
                                   
                                           <InputPassword type="password" value={reqPass.password2} valChange={valChange3} goNext={goNext3} name="password2" placeholder={"Powtórz hasło: "} className='p100'  req='1' />                      

                                           <InputText type="text" value={reqPass.code} valChange={valChange3} goNext={goNext3} name="code" placeholder={"*Kod SMS: "} className='p100'  req='0' />                      

                                            <span>*Kod SMS może dotrzeć do Ciebie z opóźnieniem do 1 min. </span>

                                        </div>
                                    <br/>
                                    <fieldset>
                                       <span href='' className='btn' onClick={sendPass} ref={btnRef}>Dalej</span>
                                    </fieldset> 
        
                            </form>
                            <br/>
                            <br/>
                            <div>
                                 <span className='link_normal' onClick={showLoginForm}>wróć do logowania</span>                         
                            </div>
                        </div>
        
                        <div className='e_foot_x'>
                                Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl 2024
                        </div>
                </div>
            )
    
    
        }
 


    var infoX = null;
    
    if(document.location.href.includes("t=parent"))
    {
        infoX = <div>
                     <div className='small_info'>
                        Aby się zalogować podaj login i hasło. Dane te otrzymałeś lub otrzymałaś od dyrektora placówki drogą elektroniczną lub za pomocą wiadomości sms.
                     </div>

                     <div className='small_info link_bad'>
                         Uwaga, adres e-mail i nr telefonu <u>nie jest loginem</u>. Login otrzymujesz od dyrektora placówki i jest on niezmienny. 
                     </div>

                </div>
    }

    if(document.location.href.includes("t=emp"))
        {
            infoX = <div>
                         <div className='small_info'>
                            Aby się zalogować podaj login i hasło. Dane te otrzymałeś lub otrzymałaś od dyrektora placówki drogą elektroniczną lub za pomocą wiadomości sms.
                         </div>
    
                         <div className='small_info link_bad'>
                             Uwaga, adres e-mail i nr telefonu <u>nie jest loginem</u>. Login otrzymujesz od dyrektora placówki i jest on niezmienny. 
                         </div>
    
                    </div>
        }

        

    if(auth2Crypt.length > 5  )    
    {
                return (
                        <div className='elizak '>

                                

                                <div className="form_content">

                                    <img src={logo_poziom} className="img_logo" />

                                    {infoX}

                                    {msgDialog}

                                     {
                                        responseUser != null && 
                                        <h3 className="calColor"> <img src={mini_lock}  className="mini_lock" /> {responseUser.name} {responseUser.last_name} </h3>
                                     }                              
                                    

                                     <p>
                                       Właśnie wysłaliśmy do Ciebie <b>sms</b> i <b>e-mail</b> z kodem bezpieczeństwa. <br/> Potwierdź swoją tożsamość podając prawidłowy kod.
                                     </p>
                                    <br/>
                                    
                                                        
                                    <form className="form" onSubmit={handleSubmit}  >

                                            <div className='filedset_block'>
                                                    <InputText  value={req.auth2_code} valChange={valChange} goNext={sendDataAuth2} name="auth2_code" placeholder={ "Kod: "} className='p50' req='1' />   
                                                </div>
                                        
                                            <fieldset>
                                            <span href='' className='btn'  ref={btnRef} onClick={sendDataAuth2} ref={btnRef} >Zatwierdź kod</span>
                                            </fieldset> 

                                    </form>
                                    <br/>
                                    
                                    <div>
                                        <span  className='link_normal' onClick={resetLogin}>wróc do strony logowania</span>                         
                                    </div>
                                </div>

                                <div className='e_foot_x'>
                                    Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl 2025, wersja:  <b>{Config.app_version} </b>
                                </div>
                        </div>
                    )
    }



    return (
        <div className='elizak '>

                

                <div className="form_content">

                    <img src={logo_poziom} className="img_logo" />

                    {infoX}

                    {msgDialog}

                     
                       <h3 className="calColor">Witaj ponownie!</h3>
                
                    
                                        
                    <form className="form"  onSubmit={handleSubmit}  >

                               <div className='filedset_block'>
                                      <InputUsername  value={req.username} valChange={valChange} goNext={goNext} name="username" placeholder={props.userData.dic.login + ": "} className='p100' req='1' />
                                                      
                                      <InputPassword type="password" value={req.password} valChange={valChange} goNext={goNext} name="password" placeholder={props.userData.dic.password + ": "} className='p100'  req='1' />                      
                                   
                                </div>
                           
                            <fieldset>
                               <span href='' className='btn'  ref={btnRef} onClick={sendData} >{props.userData.dic.gologin}</span>
                            </fieldset> 

                    </form>
                    <br/>
                    
                    <div>
                         <span  className='link_normal' onClick={showPassBackForm}>{props.userData.dic.forgot_pass}</span>                         
                         <br/>&nbsp;
                    </div>
                </div>

                <div className='e_foot_x'>
                    Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl 2025, wersja:  <b>{Config.app_version} </b>
                </div>
        </div>
    )
}

export default LoginForm;